import React, { useState, useEffect, useRef } from "react";
import "./index.css";
import { Button, message, Spin } from "antd";
import LodestarTipsCard from "./components/LodestarTipsCard";
import ClosingCost from "./components/ClosingCost";
import { track } from "statsig";
import { STATSIG, PAGE } from "statsig/events";

const Estimatedclosingfee = () => {
    const [messageApi, contextHolder] = message.useMessage();
    const [loading, setLoading] = useState(false)
    const [btnLoading, setBtnLoading] = useState(false)
    const [lodeStarConfig, setLodeStarConfig] = useState({
        "suggestEnableCount": 1,
        "isModified": false,
        "enableOriginationCharges": false,
        "enableCanNotShopServices": false,
        "enableCanShopServices": false,
        "enableTaxesAndOtherGovernmentFees": false,
        "enablePrepaids": false,
        "enableInitialEscrowPaymentsAtClosing": false,
        "enableOther": false
    })
    const [closingFeeConfig, setClosingFeeConfig] = useState({
        originationCharges: null,
        canNotShopServices: null,
        canShopServices: null,
        taxesAndOtherGovernmentFees: null,
        prepaids: null,
        initialEscrowPaymentsAtClosing: null,
        other: null,
    })
    const closingCostRef = useRef()
    const savingRef = useRef(false)
    useEffect(() => {
        track(STATSIG.COMMON.VIEW, PAGE.CLOSING_COST_SETTING, { page: PAGE.CLOSING_COST_SETTING })
        getloanestimatedclosingfee()
    }, [])

    let setEstClosingfee = (nextLodeStarConfig, closingFeeConfig, showSuccessMessage = false, lodestarTrack) => {
        if (savingRef.current) {
            return
        }
        const previousLodeStarConfig = lodeStarConfig
        const savedLodeStarConfig = {
            ...nextLodeStarConfig,
            isModified: true,
            enableCanNotShopServices: false,
            enablePrepaids: false,
            enableInitialEscrowPaymentsAtClosing: false
        }
        let data = {
            lodeStarConfig: savedLodeStarConfig,
            closingCostsDetail: closingFeeConfig
        }
        let token = sessionStorage.getItem("ZeitroA");
        savingRef.current = true
        setLodeStarConfig(savedLodeStarConfig)
        setBtnLoading(true)
        fetch("/los/setloanestimatedclosingfee", {
            cache: "no-cache",
            method: "POST",
            headers: {
                Authorization: "Bearer " + token,
                "Content-Type": "application/json",
                Cache: "no-cache",
            },
            body: JSON.stringify(data)
          }).then(response => {
            if (!response.ok) {
                throw new Error(`Unable to save closing cost settings (${response.status})`)
            }
            if (showSuccessMessage) {
                track(STATSIG.CLOSING_COST_SETTING.UPDATE)
                messageApi.open({
                    type: 'success',
                    content: <div className="closing-cost-update-message-content">Closing cost settings has been successfully updated.</div>,
                    className: 'closing-cost-update-message',
                })
            } else if (lodestarTrack) {
                track(STATSIG.CLOSING_COST_SETTING.UPDATE)
            }
        }).catch(error => {
            setLodeStarConfig(previousLodeStarConfig)
            messageApi.error(error.message || 'Unable to save closing cost settings.')
        }).finally(() => {
            savingRef.current = false
            setBtnLoading(false)
        })
    }
    const getloanestimatedclosingfee = () => {
        let token = sessionStorage.getItem("ZeitroA")
        setLoading(true)
        fetch("/los/getloanestimatedclosingfee", {
          method: "GET",
          headers: {
            Authorization: "Bearer " + token,
            Cache: "no-cache",
          },
        })
        .then((response) => {
            setLoading(false)
            if (response.status !== 200) {
                alert(
                    "Looks like there was a problem. Status Code: " + response.status
                );
                return
            }
            response.json().then((js) => {
                if (js.status !== "OK") {
                console.log("Error: " + js.Error)
                } else {
                    let data = js.configurations
                    if (data.estimatedClosingCostsDetail) {
                        setClosingFeeConfig(data.estimatedClosingCostsDetail)
                    }
                    if (data.lodeStarConfig) {
                        setLodeStarConfig(data.lodeStarConfig)
                    }
                }
            })
        })
        .catch(function (err) {
            setLoading(false)
            console.log("Fetch Error :-S", err);
        })
    }
    const handleLodestarChange = (checked) => {
        let newLodeStarConfig = {
            ...lodeStarConfig,
            "enableCanShopServices": checked,
            "enableTaxesAndOtherGovernmentFees": checked,
            "enableOther": checked
        }
        const closingFee = closingCostRef.current.getClosingFee()
        setEstClosingfee(newLodeStarConfig, closingFee, false, { section: 'all', enabled: checked })
    }
    const handleSaveChanges = () => {
        const closingFee = closingCostRef.current.getClosingFee()
        setEstClosingfee(lodeStarConfig, closingFee, true)
    }
    const handleConfigChange = (newConfig) => {
        const closingFee = closingCostRef.current.getClosingFee()
        const sectionMap = {
            enableCanShopServices: 'can_shop',
            enableTaxesAndOtherGovernmentFees: 'taxes',
            enableOther: 'other',
        }
        const changedKey = Object.keys(sectionMap).find(
            (key) => newConfig[key] !== lodeStarConfig[key]
        )
        setEstClosingfee(
            newConfig,
            closingFee,
            false,
            changedKey
                ? { section: sectionMap[changedKey], enabled: newConfig[changedKey] }
                : undefined
        )
    }
    return (
        <Spin wrapperClassName="estimatedclosingfee-loading" spinning={loading}>
            {contextHolder}
            <div className='estimatedclosingfee-wrapper'>
            <div className='estimatedclosingfee-title'>
                <div className="estr-fee-title">Loan estimated closing fee prefill</div>
                <Button type='primary' loading={btnLoading} className="estr-fee-save-btn" onClick={handleSaveChanges}>Save changes</Button>
            </div>
            <div style={{marginBottom: 12}}>
                <LodestarTipsCard initialConfig={lodeStarConfig} onLodestarChange={handleLodestarChange} disabled={btnLoading} />
            </div>
            <div className="estimatedclosingfee-container">
                <ClosingCost 
                    ref={closingCostRef}
                    initialConfig={lodeStarConfig}
                    initialClosingFee={closingFeeConfig}
                    onConfigChange={handleConfigChange}
                    configDisabled={btnLoading}
                />
            </div>
        </div>
        </Spin>
        
    )
}

export default Estimatedclosingfee
